/* The header CSS forces the badge to display, so hide it explicitly at zero.
   Observe only cart links; their native navigation needs no JavaScript. */
(function () {
  var observers = new WeakMap();

  function paintBadge(link) {
    var badge = link.querySelector('span[x-text]');
    if (!badge) return;
    var count = parseInt(badge.textContent, 10);
    badge.hidden = !(count > 0);
    if (link.dataset.aobCartLabel) link.setAttribute('aria-label', link.dataset.aobCartLabel + ' (' + (count > 0 ? count : 0) + ')');
  }

  function init(root) {
    root.querySelectorAll('.site-header a[data-aob-cart-link]').forEach(function (link) {
      paintBadge(link);
      if (observers.has(link)) return;
      var observer = new MutationObserver(function () { paintBadge(link); });
      observer.observe(link, { childList: true, subtree: true, characterData: true });
      observers.set(link, observer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('.site-header a[data-aob-cart-link]').forEach(function (link) {
      var observer = observers.get(link);
      if (observer) observer.disconnect();
      observers.delete(link);
    });
  });
})();
